/* eslint-disable max-lines-per-function */
import { useQuery } from "@apollo/client";
import React from "react";
import css from "classnames";
import MaterialTable from "@material-table/core";
import { Button } from "components/haven-design/buttons";
import { WaitlistUpdateQuery, WaitlistUpdateQueryVariables, WaitlistUpdateRequestStatus,
  WaitlistUpdateQuery_interestList_scheduledUpdate_requested_results as QueryResult } from "types/gql-types";
import { useTablesRef } from "components/table-refs";
import { WAITLIST_UPDATE_QUERY } from "../query";
import { InterestList } from "../../types";
import contentStyles from "./content.module.css";
import { NameColumnRaw, PhoneColumn } from "./custom-columns";

const DEFAULT_PAGE_SIZE = 10;

const statusName = {
  [WaitlistUpdateRequestStatus.ALL_BOUNCED]: "All messages have bounced",
  [WaitlistUpdateRequestStatus.NO_RESPONSE]: "Has not yet responded",
  [WaitlistUpdateRequestStatus.RESPONDED]: "Responded",
  [WaitlistUpdateRequestStatus.UNREACHABLE]: "No contact information available",
  [WaitlistUpdateRequestStatus.UNREACHABLE_LANDLINE_ONLY]: "Landline only",
};
const tableOptions = {
  sorting: false,
  showTitle: false,
  pageSize: DEFAULT_PAGE_SIZE,
  pageSizeOptions: [10, 20, 50],
  paginationType: "stepped" as const,
  search: false,
  toolbar: false,
};

export const ContentSection: React.FC<{
  selectedStatus: WaitlistUpdateRequestStatus,
  setStatus: React.Dispatch<React.SetStateAction<WaitlistUpdateRequestStatus | null>>,
  interestList: InterestList,
}> = ({ selectedStatus, setStatus, interestList }) => {
  const { waitlistUpdateTableRef } = useTablesRef();
  const [totalCount, setTotalCount] = React.useState(0);
  const variables = { id: interestList.id,
    statuses: [selectedStatus],
    limit: DEFAULT_PAGE_SIZE,
    offset: 0 };
  const results = useQuery<
  WaitlistUpdateQuery,
  WaitlistUpdateQueryVariables
  >(WAITLIST_UPDATE_QUERY, { variables, notifyOnNetworkStatusChange: true });

  return (
    <div>
      <div className={css(contentStyles.controls)}>
        <div>
        Viewing: {statusName[selectedStatus]} (
          {totalCount})
        </div>
        <div>
          <Button onClick={() => setStatus(null)} color="primary" size="S">
          Go back
          </Button>
        </div>
      </div>
      <MaterialTable<QueryResult>
        tableRef={waitlistUpdateTableRef}
        columns={[
          { title: "Name", field: "name", render: (rowData) => <NameColumnRaw {...rowData} /> },
          { title: "Phone", field: "phone", render: (rowData) => <PhoneColumn value={rowData.phone ?? ""} /> },
        ]}
        data={(query) => {
          const limit = query.pageSize;
          const offset = query.page * limit;
          const { search } = query;
          return results.fetchMore({
            variables: {
              search,
              offset,
              limit,
            },
            updateQuery: (prev, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prev;
              return fetchMoreResult;
            },
          }).then((res) => {
            const {
              results: newRows, totalCount: newTotalCount,
            } = res.data.interestList.scheduledUpdate.requested;

            setTotalCount(newTotalCount);
            return {
              data: newRows,
              page: query.page,
              totalCount: newTotalCount,
            };
          });
        }}
        options={tableOptions}

      />
    </div>
  );
};
